if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.syncFromProductPage(opener);
        this.showActiveMedia();
        document.dispatchEvent(new CustomEvent('2in1:product-zoom-open', { detail: { modal: this } }));
      }

      syncFromProductPage(opener) {
        const page = document.querySelector('[data-product-design-page]');
        const content = this.querySelector('.product-media-modal__content');
        if (!content) return;
        const idOf = (node) => {
          const raw = String(node?.dataset?.mediaId || node?.getAttribute?.('data-media-id') || '');
          const match = raw.match(/(\d+)$/);
          return match ? match[1] : raw;
        };
        const byId = new Map();
        const urls = [];
        (page ? [...page.querySelectorAll('.product__media-list .product__media-item')] : []).forEach((item) => {
          if (item.style.display === 'none') return;
          const img = item.querySelector('img');
          const src = img?.currentSrc || img?.getAttribute('src') || '';
          if (!src) return;
          urls.push(src);
          [idOf(item), idOf(item.querySelector('[data-media-id]')), idOf(img)].filter(Boolean).forEach((id) => byId.set(id, src));
        });
        const openerImg = opener?.closest?.('.product__modal-opener')?.querySelector('img') || opener?.parentElement?.querySelector('img');
        const openerSrc = openerImg?.currentSrc || openerImg?.getAttribute?.('src') || '';
        const openerId = idOf(opener);
        if (openerId && openerSrc) byId.set(openerId, openerSrc);
        let index = 0;
        [...content.children].forEach((item) => {
          const img = item.tagName === 'IMG' ? item : item.querySelector?.('img');
          if (!img) return;
          const url = byId.get(idOf(item)) || byId.get(idOf(img)) || urls[index];
          index += 1;
          if (!url) return;
          img.removeAttribute('srcset');
          img.removeAttribute('sizes');
          img.setAttribute('src', url);
          img.setAttribute('srcset', url);
          img.style.objectFit = 'contain';
        });
      }

      showActiveMedia() {
        if (!this.openedBy) return;
        const openerId = this.openedBy.getAttribute('data-media-id');
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${openerId}"])`).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${openerId}"]`);
        if (!activeMedia) return;
        const activeMediaTemplate = activeMedia.querySelector?.('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
